import React, { useState, useEffect } from 'react';
import { useLocation, useHistory, useParams } from 'react-router-dom'; // eslint-disable-line
import apiConnect from '../../../config/apiConfig';
import { CustomButton } from '../../utils/Utils';

import {
  UserOutlined,
  WhatsAppOutlined,
  InstagramOutlined,
  FacebookOutlined,
  HomeOutlined,
  ArrowLeftOutlined,
  LogoutOutlined
} from '@ant-design/icons';
import style from './navigationUser.module.scss';

const NavigationUser = ({ brandSize, shadow, conference }) => {
  const [user, setUser] = useState([]);
  const [userExist, setUserExist] = useState(false);
  const [currentURL, setCurrentURL] = useState('');
  const userId = localStorage.getItem('id');
  const token = localStorage.getItem('jwt');

  let location = useLocation();
  let history = useHistory();
  let { hall } = useParams();

  function getCurrentURL() {
    if (hall) {
      setCurrentURL(`/${hall}`);
    } else {
      setCurrentURL(location.pathname);
    }
  }

  useEffect(() => {
    if (user.length !== 0) {
      setUserExist(true);
    } else {
      setUserExist(false);
    }
  }, [user]);

  useEffect(() => {
    getCurrentURL();
    getUser();
  }, [location]);

  const getUser = async () => {
    try {
      const { data } = await apiConnect.get(`/users/${userId}`);
      setUser(data.data[0]);
    } catch (error) {
      console.log(error); // eslint-disable-line
    }
  };

  const logout = () => {
    localStorage.removeItem('jwt');
    localStorage.removeItem('role');
    localStorage.removeItem('user');
    localStorage.removeItem('id');
    localStorage.removeItem('combosBought');
    history.push('/signPage');
  };

  const handleBackHome = () => {
    history.push('/');
  };
  const backgroundImg = `${process.env.REACT_APP_PUBLIC_ASSETS}/public/rounded_logo_expo.png`;
  return (
    <div className={`${style.container} ${shadow && style.brandShadow}`}>
      <div className={style.brand} style={{ height: brandSize, backgroundImage: `url(${backgroundImg})` }} />
      <div className={style.items}>
        <div className={`${style.nav} ${style.navClean}`}>
          {(currentURL === '/') && (
            <>
              <HomeOutlined className={style.homeIcon}></HomeOutlined>
              <p className={style.homeText}>Bienvenido a Expo 2024</p>
            </>
          )}
          {(currentURL === '/perfumery') && (
            <>
              <CustomButton onclick={handleBackHome} className={`${style.btnNav} ${style.btnClean}`} size='bg' color='btnOutline' content={<><ArrowLeftOutlined /><p className={style.btnNavText}><p className={`${style.btnNavText} ${style.backText}`}>VOLVER AL &nbsp;</p> HALL PRINCIPAL</p></>} />
              <p className={`${style.hallsText} ${style.hallsTextClean}`}>Hall: Perfumería</p>
            </>
          )}
          {(currentURL === '/dermocosmetics') && (
            <>
              <CustomButton onclick={handleBackHome} className={`${style.btnNav} ${style.btnClean}`} size='bg' color='btnOutline' content={<><ArrowLeftOutlined /><p className={style.btnNavText}><p className={`${style.btnNavText} ${style.backText}`}>VOLVER AL &nbsp;</p> HALL PRINCIPAL</p></>} />
              <p className={`${style.hallsText} ${style.hallsTextClean}`}>Hall: Dermocosmética</p>
            </>
          )}
          {(currentURL === '/medicaments') && (
            <>
              <CustomButton onclick={handleBackHome} className={`${style.btnNav} ${style.btnClean}`} size='bg' color='btnOutline' content={<><ArrowLeftOutlined /><p className={style.btnNavText}><p className={`${style.btnNavText} ${style.backText}`}>VOLVER AL &nbsp;</p> HALL PRINCIPAL</p></>} />
              <p className={`${style.hallsText} ${style.hallsTextClean}`}>Hall: Medicamentos</p>
            </>
          )}
          {(currentURL === '/conferences') && (
            <>
              <CustomButton onclick={handleBackHome} className={`${style.btnNav} ${style.btnClean}`} size='bg' color='btnOutline' content={<><ArrowLeftOutlined /><p className={style.btnNavText}><p className={`${style.btnNavText} ${style.backText}`}>VOLVER AL &nbsp;</p> HALL PRINCIPAL</p></>} />
              <p className={`${style.hallsText} ${style.hallsTextClean}`}>Hall: Conferencias</p>
            </>
          )}
          {(currentURL === '/perfil') && (
            <>
              <CustomButton onclick={handleBackHome} className={`${style.btnNav} ${style.btnClean}`} size='bg' color='btnOutline' content={<><ArrowLeftOutlined /><p className={style.btnNavText}><p className={`${style.btnNavText} ${style.backText}`}>VOLVER AL &nbsp;</p> HALL PRINCIPAL</p></>} />
              <p className={`${style.hallsText} ${style.hallsTextClean}`}><b>Perfil</b></p>
            </>
          )}
          {conference && (
            <>
              <CustomButton onclick={handleBackHome} className={`${style.btnNav} ${style.btnClean}`} size='bg' color='btnOutline' content={<><ArrowLeftOutlined /><p className={style.btnNavText}><p className={`${style.btnNavText} ${style.backText}`}>VOLVER AL &nbsp;</p> HALL PRINCIPAL</p></>} />
              <p className={`${style.hallsText} ${style.hallsTextClean}`} style={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'break-spaces',
                maxWidth: '53%'
              }}>{conference}</p>
            </>
          )}
        </div>
        <div className={style.divSession}>
          {token && (
            <>
              <div className={style.socialMedia}>
                <a href="#">
                  <WhatsAppOutlined className={style.iconSocial} />
                </a>
                <a href="https://www.facebook.com/Droguer%C3%ADa-Suiza-103860248656657/about/?ref=page_internal">
                  <FacebookOutlined className={style.iconSocial} />
                </a>
                <a href="https://www.instagram.com/drogueriasuiza.ok">
                  <InstagramOutlined className={style.iconSocial} />
                </a>
              </div>
              <div className={style.help}>
                {user.isAdmin ?
                  <CustomButton
                    content="Página admin"
                    size="sm"
                    color="btnPrimary"
                    style={{ whiteSpace: 'nowrap' }}
                    onclick={() => history.push('/admin')}
                  />
                  :
                  <CustomButton
                    content="Mis compras"
                    size="sm"
                    color="btnPrimary"
                    style={{ whiteSpace: 'nowrap' }}
                    onclick={() => history.push('/perfil')}
                  />
                }

              </div>
              <div className={style.divLogout}>
                <UserOutlined className={style.icon} />
                <h4>
                  {userExist ? (user.fullName || user.pharmacy?.name || user.accountNumber || user.email || user.pharmacy?.email) : '.....'}
                </h4>
                <CustomButton style={{ display: 'flex', alignItems: 'center' }} color="btnOrange" className={style.btnLogOut} onclick={() => logout()}>
                  <LogoutOutlined style={{ marginRight: '.25rem' }} />
                  Cerrar sesión
                </CustomButton>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default NavigationUser;
